export enum FormLoadingStatus {
  Loading = "Loading",
  Failed = "Failed",
  Success = "Success",
}
